import { useState } from "react";
import Registry from "../../models/registry.interface";


export default (): [(entity: string) => void, Registry[], string]  => {

    const [result, setResult] = useState<Registry[]>([]);
    const [errorMsg, setErrorMsg] = useState("");
    const apiServer = process.env.REACT_APP_API_SERVER_URL;

    const getResult = async (entity: string) => {
        const data = await fetch(`${apiServer}/entity/${entity}`, {
            method: "GET"
        });
        const jsonData = await data.json() as Registry[];
        if (jsonData.length > 0) setResult(jsonData)
        else {setResult([]); setErrorMsg("Cannot find Entity");}
    }
    return [getResult, result, errorMsg]
}